<template>
   <div class="container-fluid not-estimated-page">
     <div class="title-container">
       <h3 class="title">
         Not estimated tasks
         <div
           class="spinner-border spinner-theme_default"
           role="status"
           v-if="isLoading"
         >
          <span class="sr-only">
            Loading...
          </span>
         </div>
       </h3>
     </div>
     <TableForPage
       style="margin-bottom: 0;"
       v-if="notEstimatedTasks.length"
       :isLoading="isLoading"
       :tableData="notEstimatedTasks"
       :fields="headerFields"
       :slots="slots"
       :cellFixed="false"
       stickyHeader
     >
       <template v-slot:project_name="data">
         <a :href="data.item.project_url" target="_blank">
           <img :src="data.item.project_icon" class="project-icon" :alt="data.item.project_name">
           {{data.item.project_name}}
         </a>
       </template>
       <template v-slot:project_manager_name="data">
         {{data.item.project_manager_name || 'Project manager was not assigned' }}
       </template>
       <template v-slot:key="data">
         <a :href="'https://giraffesoftware.atlassian.net/browse/' + data.item.key" target="_blank">
           {{ data.item.key }}
         </a>
       </template>
       <template v-slot:type="data">
         <img
           class="issue-icon"
           :src="data.item.issue_type_icon"
           :alt="data.item.key"
         >
         <span>
           {{ data.item.type }}
         </span>
       </template>
     </TableForPage>
  </div>
</template>

<script>
import TableForPage from '@tables/TableForPage'

export default {
  name: 'NotEstimated',
  components: {
    TableForPage
  },
  data () {
    return {
      slots: {
        project_name: {
          name: 'project_name'
        },
        project_manager_name: {
          name: 'project_manager_name'
        },
        key: {
          name: 'key'
        },
        type: {
          name: 'type'
        }
      },
      headerFields: [
        {
          key: 'project_name',
          sortable: true,
          label: 'Project',
          sortDirection: 'asc'
        },
        {
          key: 'project_manager_name',
          sortable: true,
          label: 'Project manager'
        },
        {
          key: 'key',
          sortable: false,
          label: 'Issue'
        },
        {
          key: 'type',
          sortable: true,
          label: 'Issue type'
        },
        {
          key: 'status.name',
          sortable: true,
          label: 'Status'
        },
        {
          key: 'assignee.displayName',
          sortable: true,
          label: 'Assignee'
        },
        {
          key: 'reporter_name',
          sortable: false,
          label: 'Reporter'
        },
        {
          key: 'last_update',
          sortable: true,
          label: 'Date updated'
        }
      ],
      isLoading: false
    }
  },
  created () {
    this.fetchNotEstimatedTasks()
  },
  computed: {
    notEstimatedTasks () {
      /* TODO GB2-863 - remove method addNotEstimated */
      return this.addNotEstimated(this.$store.getters.getNotEstimatedIssues) || []
    }
  },
  methods: {
    fetchNotEstimatedTasks () {
      this.isLoading = true
      this.$api.notEstimated.fetchNotEstimatedTasks().then(resposne => {}).catch(e => {})
        .finally(() => {
          this.isLoading = false
        })
    },
    /* TODO GB2-863 - remove method addNotEstimated */
    addNotEstimated (data) {
      if (!data || !data.length) return data

      return data.map(item => {
        return {
          ...item
        }
      })
    }
  }
}
</script>

<style lang="scss" >
.not-estimated-page {
    .spinner-border {
        position: relative;
        top: 0;
    }

    .not-estimated-table {
        max-height: calc(100vh - 200px);
    }

  .issue-icon {
    position: relative;
    top: -2px;
    margin-right: 3px;
  }

  .project-icon {
    position: relative;
    max-width: 20px;
    top: -2px;
    margin-right: 5px;
  }
}

</style>
